`<template>
    <div
        id="app"
        :class="{'f0f2f5':!$route.meta.hideNfHead,'ffffff':$route.meta.hideNfHead}"
    >
        <nf-header v-show="!$route.meta.hideNfHead && JSON.stringify($route.meta)!=='{}'" />
        <router-view />
    </div>
</template>

<script>
import nfHeader from '@/components/nf-header/index'
export default {
    name: 'App',
    components: {
        nfHeader
    },
    watch: {
        '$route' (data) {
            this.$store.commit('uppdateNavMenuActive', data.meta.NavMenuActive ? data.meta.NavMenuActive : data.path)
        }
    },
}
</script>

<style>
@import './assets/styles/reset.css';
@import './assets/styles/base.scss';
html,
body {
    width: 100%;
    height: 100%;
}
#app {
    font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB',
        'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width: 100%;
    height: 100%;
    min-width: 1280px;
    display: flex;
    flex-direction: column;
}
.f0f2f5 {
    background: #f0f2f5;
}
.ffffff {
    background: #fff;
}
</style>